import React, { useEffect, useRef, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import Langs, { Localize } from '../../app/lang/langs';
import styles from './Ventr.module.css';
import { useSelector, useDispatch } from 'react-redux';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import { ViewSelectButton } from '../../components/buttons/ViewSelectButton';
import { useNavigate, useParams } from 'react-router-dom';
import { getInterviews, InterviewsTypesOptions, statusOptions } from './VentrSlice';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import moment from 'moment';
import interview from "../../assets/images/interview.png";
import interviewFocus from "../../assets/images/interviewFocus.png";
import ImageButton from '../../components/buttons/ImageButton';
import InterviewModal from './InterviewModal';
import { FilterMatchMode } from 'primereact/api';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import { MultiSelect } from 'primereact/multiselect';
import exportIcon from "../../assets/images/export.png";
import exportIconFocus from "../../assets/images/exportFocus.png";
import ExcelManager from '../../app/managers/excelManager';
import { safeParse } from '../../app/utils/helpers';

// Mobile sub-components
import MobileVentrTopMenu from './mobile/MobileVentrTopMenu';
import MobileInterviewsList from './mobile/MobileInterviewsList';
import MobileInterviewModal from './mobile/MobileInterviewModal';
import { config } from '../../app/utils/config';

const VentrView = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const urlParams = useParams()

    const [selectedView, setSelectedView] = useState()
    const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds)
    const mounted = useRef(null)
    const userPermissions = useSelector((state) => state.login.permissions)
    const userId = useSelector((state) => state.login.userId)

    const [isManager, setIsManager] = useState()
    const [isCollab, setIsCollab] = useState()

    useEffect(() => {

        const ventrPerms = Array.isArray(userPermissions)
            ? userPermissions.filter(p => p.scope === config.scopes.ventr)
            : []

        const canViewAll = ventrPerms.some(p => p.id_team === null || p.id_team === undefined)
        const canViewTeam = !canViewAll && ventrPerms.length > 0

        setIsCollab(!canViewAll && !canViewTeam)
        setIsManager(canViewTeam)
    }, [userPermissions])

    useEffect(() => {
        if (!mounted.current) {
            dispatch(getInterviews())
        }
        mounted.current = true
    }, [mounted])


    const allInterviews = useSelector((state) => state.ventr.interviewsList)
    const isMobile = useSelector((state) => state.settings.isMobile);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        collab_nom: { value: null, matchMode: FilterMatchMode.CONTAINS },
        collab_prenom: { value: null, matchMode: FilterMatchMode.CONTAINS },
        status: { value: null, matchMode: FilterMatchMode.IN },
        type: { value: null, matchMode: FilterMatchMode.IN },
        team_name: { value: null, matchMode: FilterMatchMode.CONTAINS }
    })

    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [upcomingInterviews, setUpcomingInterviews] = useState([]);
    const [doneInterviews, setDoneInterViews] = useState([]);
    const [otherInterviews, setOtherInterviews] = useState([]);
    const [onEditInterview, setOnEditInterview] = useState(null);
    const [onEditInterviewVisible, setOnEditInterviewVisible] = useState(false);

    const currList = (view) => {
        if (isCollab) {
            return upcomingInterviews.concat(doneInterviews)
        }
        let list = []
        switch (view) {
            case '0':
                if (isManager) {
                    list = upcomingInterviews.concat(doneInterviews)
                } else {
                    list = upcomingInterviews
                }
                break
            case '1':
                if (isManager) {
                    list = otherInterviews
                } else {
                    list = doneInterviews
                }
                break
        }
        return list
    }

    useEffect(() => {
        setUpcomingInterviews(allInterviews?.upcoming ? allInterviews.upcoming : [])
        setDoneInterViews(allInterviews?.done ? allInterviews.done : [])
        setOtherInterviews(allInterviews?.others ? allInterviews.others : [])
    }, [allInterviews])

    const viewsOptions = [
        { label: <Langs str='UPCOMING_INTERVIEWS' />, value: 0 },
        { label: <Langs str='DONE_INTERVIEWS' />, value: 1 }
    ]

    const managerViewsOptions = [
        { label: <Langs str='Mes entretiens' />, value: 0 },
        { label: <Langs str='Collabs entretiens' />, value: 1 }
    ]

    useEffect(() => {
        if (urlParams.subView && viewsOptions[urlParams.subView]) {
            setSelectedView(urlParams.subView)
        }
    }, [urlParams])

    const handleViewChange = (view) => {
        if (view != null) {
            let selectedTeamId = selectedTeamsIds[0]
            let filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                collab_nom: { value: null, matchMode: FilterMatchMode.CONTAINS },
                collab_prenom: { value: null, matchMode: FilterMatchMode.CONTAINS },
                type: { value: null, matchMode: FilterMatchMode.CONTAINS },
                team_name: { value: null, matchMode: FilterMatchMode.CONTAINS }
            }
            if (view == '0') {
                filters.status = { value: null, matchMode: FilterMatchMode.IN }
            }
            setFilters(filters)
            navigate(`/ventr/${selectedTeamId}/${view}`)
        }
    }

    const statusTemplate = (rowData) => {
        let color, label = rowData.status
        statusOptions.map(o => {
            if (o.value == rowData.status) {
                color = o.color
                label = o.label
            }
        })
        return <label className={styles.clickableLabel} style={{ color: color }} onClick={(e) => {
            setOnEditInterview(rowData)
            setOnEditInterviewVisible(true)
        }}><strong><Langs str={label} /></strong></label>
    }

    const statusItemTemplate = (option) => {
        return <label style={{ color: option.color }}><strong><Langs str={option.label} /></strong></label>
    }

    const statusRowFilterTemplate = (options) => {

        return (
            <MultiSelect
                value={options.value}
                options={statusOptions.filter(o => o.value != 'done')}
                itemTemplate={statusItemTemplate}
                onChange={(e) => options.filterApplyCallback(e.value)}
                optionLabel="label"
                placeholder="Any"
                className="p-column-filter"
                style={{ minWidth: '14rem' }}
            />
        )
    }

    const typeRowFilterTemplate = (options) => {

        return (
            <MultiSelect
                value={options.value}
                options={InterviewsTypesOptions}
                onChange={(e) => options.filterApplyCallback(e.value)}
                optionLabel="label"
                placeholder="Any"
                className="p-column-filter"
                style={{ minWidth: '14rem' }}
            />
        );
    }

    const dateTemplate = (rowData, options) => {
        if (rowData[options.field]) {
            return <div>{moment(rowData[options.field]).format('DD-MM-YYYY')}</div>
        } else {
            return <div>N/A</div>
        }
    }

    const dateTimeTemplate = (rowData, options) => {
        if (rowData[options.field]) {
            return <div>{moment(rowData[options.field]).format('DD-MM-YYYY HH:mm')}</div>
        } else {
            return <div>N/A</div>
        }
    }

    const editInterviewButton = (rowData) => {
        return (
            <ImageButton
                image={interview}
                imageFocus={interviewFocus}
                onClick={() => {
                    setOnEditInterview(rowData)
                    setOnEditInterviewVisible(true)
                }}
                active={true}
                width={32}
            />
        )
    }

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    }

    const navToTeam = (rowData) => {
        const encodedLabel = encodeURIComponent(rowData.current_team_name)
        navigate(`/clients/${selectedTeamsIds[0]}/1/${encodedLabel}`)
    }

    const exportExcelInterviews = () => {

        let exportDataInterviews = currList(selectedView).reduce((array, current) => {
            let desiredTraining = current.desired_training && safeParse(current.desired_training, {})
            let trainingCompleted = current.training_completed ? safeParse(current.training_completed, []) : []
            let professionalProject = current.professional_project && safeParse(current.professional_project, {})
            let interviewData = {
                "Prénom": current.collab_prenom || "",
                "Nom de famille": current.collab_nom || "",
                "Equipe": current.team_name || "",
                "Type": current.type || "",
                "Statut": current.status || "",
                "Date d'ancienneté": current.anciennetee_date ? moment(current.anciennetee_date).format("DD-MM-YYYY") : "",
                "Date théorique de l'entretien": current.theoretical_date ? moment(current.theoretical_date).format("DD-MM-YYYY HH:mm") : "",
                "Date de l'entretien": current.planned_date ? moment(current.planned_date).format("DD-MM-YYYY HH:mm") : "",
                "Entretien réalisé par": current.interviewed_by || "",
                "Commentaires RH": current.rh_comment || "",
                "Commentaires Collaborateur": current.collab_comment || "",
                "Formation souhaitée": desiredTraining && desiredTraining[0]?.name || "",
                "Formation période souhaitée": desiredTraining && desiredTraining[0]?.period || "",
                "Financement formation": desiredTraining && desiredTraining[0]?.funding || "",
                "Formation souhaitée commentaires": desiredTraining && desiredTraining[0]?.comments || "",
                "Mobilité géographique": professionalProject && professionalProject[0]?.location || "",
                "Période souhaitée": professionalProject && professionalProject[0]?.desired_period || "",
                "Réorientation": professionalProject && (professionalProject[0]?.reorient == "Yes" ? "Oui" : "Non") || "",
                "Réorientation commentaires": professionalProject && professionalProject[0]?.reorient_comments || "",
                "Prise de responsabilité": professionalProject && (professionalProject[0]?.responsibility == "Yes" ? "Oui" : "Non") || "",
                "Prise de responsabilité commentaires": professionalProject && professionalProject[0]?.responsibility_comments || "",
                "Changer de mission/fonction": professionalProject && (professionalProject[0]?.change_mission == "Yes" ? "Oui" : "Non") || "",
                "Changer de mission/fonction commentaires": professionalProject && professionalProject[0]?.comments || "",
                "Progression - Evolution professionnelle": professionalProject && professionalProject[0]?.progressQ1 || "",
                "Progression - Changement de statut / de coefficient": professionalProject && professionalProject[0]?.progressQ2 || "",
                "Progression - Augmentation salariale ": professionalProject && professionalProject[0]?.progressQ3 || "",
                "Formations Suivies": trainingCompleted.reduce((array, item) => {
                    array.push(`Nom : ${item.name} | Début : ${item.start_date && moment(item.start_date).format("YYYY-MM-DD")} | Fin : ${item.date && moment(item.date).format("YYYY-MM-DD")} | Origine : ${item.origin} | Financement : ${item.funding} | Certificat obtenu : ${item.certificate_obtained == "Yes" ? "Oui" : "Non"} | Formations suivie au sein de VITAL: ${item.formation_vital == "Yes" ? "Oui" : "Non"} | Evaluation : ${item.assessment}`)
                    return array
                }, []).join("\n\n")
            }

            array.push(interviewData)
            return array
        }, [])
        ExcelManager.getInstance().generateAndDownloadExcelFromData(exportDataInterviews, "entretiens_collaborateurs")
    }

    const header = () => {
        return (
            <div className="d-flex justify-content-between" style={{ width: '100%' }}>
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                </IconField>
                {/* <ImageButton
                    image={addIcon}
                    imageFocus={addIconFocus}
                    onClick={() => setAddInterviewModalVisible(true)}
                    active={true}
                    tooltip={<Langs str="ADD_INTERVIEW" />}
                    width={32} /> */}
            </div>
        )
    }

    const headerTitle = () => {
        if (isCollab) {
            return <h3><Langs str="Mes entretiens" /></h3>
        } else if (isManager) {
            return <ViewSelectButton
                options={managerViewsOptions}
                selectedView={managerViewsOptions.find(o => o.value == selectedView)?.value}
                onViewChange={handleViewChange}
            />
        } else {
            return <ViewSelectButton
                options={viewsOptions}
                selectedView={viewsOptions.find(o => o.value == selectedView)?.value}
                onViewChange={handleViewChange}
            />
        }
    }

    // -----------------------------------------------------------------------
    // Mobile render
    // -----------------------------------------------------------------------
    if (isMobile === 2) {
        const mobileViewsOptions = isManager ? managerViewsOptions : viewsOptions
        return (
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
                <div style={{ flexShrink: 0 }}>
                    <MobileVentrTopMenu
                        viewsOptions={mobileViewsOptions}
                        selectedView={selectedView}
                        onViewChange={handleViewChange}
                        onExport={exportExcelInterviews}
                        isCollab={isCollab}
                    />
                </div>
                <div style={{ flex: 1, overflow: 'hidden' }}>
                    <MobileInterviewsList
                        data={currList(selectedView)}
                        onRowClick={(rowData) => { setOnEditInterview(rowData); setOnEditInterviewVisible(true) }}
                        statusOptions={statusOptions}
                        typeOptions={InterviewsTypesOptions}
                        showStatusFilter={!isCollab && selectedView == '0'}
                    />
                </div>
                <MobileInterviewModal
                    interview={onEditInterview}
                    setInterview={setOnEditInterview}
                    visible={onEditInterviewVisible}
                    setVisible={setOnEditInterviewVisible}
                />
            </div>
        )
    }

    // -----------------------------------------------------------------------
    // Desktop render
    // -----------------------------------------------------------------------
    return (
        <div>
            <div className={styles.topMenu}>
                <Row style={{ width: "100%" }}>
                    <Col lg={3}>
                        <span className="headerTitle">
                            {<Langs str="V-Entr" />}
                        </span>
                    </Col>
                    <Col lg={6} className='d-flex justify-content-center'>
                        {headerTitle()}
                    </Col>
                    <Col lg={3} className="d-flex justify-content-end pe-4 align-items-center p-0 m-0 ms-auto">
                        {!isCollab && <div>
                            <ImageButton
                                image={exportIcon}
                                imageFocus={exportIconFocus}
                                onClick={exportExcelInterviews}
                                active={true}
                                tooltip={<Langs str={selectedView == 0 ? "Export entretiens à venir" : "Export entretiens terminés"} />}
                                width={32} />
                        </div>}
                    </Col>
                </Row>

            </div>
            <div className={styles.bodyContainer}>
                <div className="card p-1 mt-3" style={{
                    height: 'calc(100vh - 160px)',
                    background: 'rgba(255, 255, 255, 0.8)',
                    backdropFilter: 'blur(6px)',
                    WebkitBackdropFilter: 'blur(6px)',
                    borderRadius: '14px',
                    border: '1px solid rgba(0, 40, 128, 0.06)',
                    boxShadow: '0 1px 4px rgba(255, 144, 21, 0.04), 0 4px 16px rgba(0, 40, 128, 0.03)',
                    overflow: 'hidden'
                }}>
                    <DataTable
                        value={currList(selectedView)}
                        scrollHeight={isMobile === 2 ? "calc(100vh - 200px)" : "calc(100vh - 305px)"}
                        scrollable
                        paginator
                        stripedRows
                        currentPageReportTemplate={`{first} ${Localize("to")} {last} ${Localize("of")} {totalRecords}`}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        rows={25}
                        sortMode="single"
                        globalFilterFields={['collab_nom', 'collab_prenom', 'type', 'status']}
                        filters={filters}
                        header={!isCollab && !isManager ? header : null}
                        rowHover
                        selectionMode="single"
                        onRowDoubleClick={(e) => {
                            setOnEditInterview(e.data)
                            setOnEditInterviewVisible(true)
                        }}
                    >
                        <Column filter filterMatchMode={'contains'} filterPlaceholder="prenom" header={<Langs str='prenom' />} field='collab_prenom' sortable />
                        <Column filter filterMatchMode={'contains'} filterPlaceholder="nom" header={<Langs str='nom' />} field='collab_nom' sortable />
                        <Column field="team_name" header={Localize("Team")} filter sortable style={{ minWidth: '9rem' }}></Column>
                        <Column filter filterMatchMode={'contains'} showFilterMenu={false} filterPlaceholder="type" filterElement={typeRowFilterTemplate} header={<Langs str='TYPE_INTERVIEW' />} field='type' />
                        <Column header={<Langs str='STATUS' />} body={statusTemplate} sortable field='status' filter filterPlaceholder="status" filterElement={statusRowFilterTemplate} />
                        <Column header={<Langs str="Date d'ancienneté" />} sortable field='anciennetee_date' body={dateTemplate}></Column>
                        <Column header={<Langs str='INTERVIEW_THEORETICAL_DATE' />} sortable field='theoretical_date' body={dateTemplate}></Column>
                        <Column header={<Langs str='INTERVIEW_PLANNED_DATE' />} sortable field='planned_date' body={dateTimeTemplate}></Column>
                    </DataTable>
                </div>
            </div>
            <InterviewModal
                interview={onEditInterview}
                setInterview={setOnEditInterview}
                visible={onEditInterviewVisible}
                setVisible={setOnEditInterviewVisible}
            />
        </div>
    )
}

export default VentrView;
